import { BODY_SM_SM_STYLES, HEADING_XS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const EvaluationScaleWrapper = styled.div`
    display: flex;
    padding: var(--spacing-sm, 16px);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-sm, 16px);
`;

export const Heading = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_XS_STYLES};
`;

export const Text = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
`;

export const BoldText = styled(Text)`
    font-weight: 700;
    color: var(--colors-text-headings, #3e445c);
`;

export const Table = styled.div`
    width: 100%;
    border-radius: 8px;
`;

export const HeaderRow = styled.div`
    display: grid;
    grid-template-columns: 200px 124px 1fr;

    background: var(--colors-grey-150, #f1f4f8);
    border-top: 1px solid var(--colors-grey-200, #e2e8f0);
    border-bottom: 1px solid var(--colors-grey-200, #e2e8f0);
`;

export const Row = styled.div`
    display: grid;
    grid-template-columns: 220px 100px 1fr;

    border-bottom: 1px solid var(--colors-grey-200, #e2e8f0);
`;

export const HeaderCell = styled.div`
    padding: 8px 16px;
    color: var(--colors-text-headings, #3e445c);
    ${BODY_SM_SM_STYLES};
    font-weight: bold;
`;

export const Cell = styled.div`
    padding: 8px 16px;
    display: flex;
    align-items: center;
`;

export const DescriptionCell = styled(Cell)`
    display: block;

    ul {
        margin: 0;
        padding-left: 24px;
        list-style: none;
        padding-inline-start: var(--spacing-2xs, 4px);
    }
`;

export const Rating = styled(BoldText)<{
    $type: 'success' | 'error' | 'default';
}>`
    color: ${({ $type }) => {
        switch ($type) {
            case 'success':
                return 'var(--colors-text-success, #22A06B)';
            case 'error':
                return 'var(--colors-red-450, #E14B53)';
            case 'default':
            default:
                return 'var(--colors-text-headings, #3E445C)';
        }
    }};
`;

export const ButtonWrapper = styled.div`
    text-align: center;

    .ant-btn {
        width: 352px;
    }
`;
